import { Injectable, signal, WritableSignal } from '@angular/core';
import { styleSheetInterface } from 'src/app/util/interfaces/styleSheet';

@Injectable({
	providedIn: 'root',
})
export class StylesheetService {
	stylesheet: WritableSignal<{ [key: string]: string }> = signal({});
	constructor() {}

	setStylesheet(stylesheet: { [key: string]: string }) {
		this.stylesheet.set(stylesheet);
	}

	setStylesheetColor(colorKey: string, colorValue: string) {
		const currentStylesheet = this.stylesheet();
		currentStylesheet[colorKey] = colorValue;
		this.stylesheet.set(currentStylesheet);
	}
}
